import React, { useContext } from "react"
import {
  AutoPilot,
  BetAmount,
  BetAmountContainer,
  BetAmountWrapper,
  BetBlock,
  BetBlockWrapper,
  Operation,
  Operations,
  SubText,
  Text,
  BetButton,
} from "../GameRulesStyles"
import { AppContext } from "../../../context/createContext"

export default function AutoplayRules() {
  const {
    config,
    auth: { balance },
  } = useContext(AppContext)
  return (
    <>
      <Text className={"big blue"} margin={"0 0 10px"}>
        Autopilot
      </Text>
      <Text className={"big white"} margin={"0 0 10px"}>
        YOU CAN CUSTOMIZE YOUR BET SECTIONS WITH AUTOPLAY FEATURES AS MANUAL,
        WITH SIMPLE CLICK SECTION WILL EXPAND WITH FOLLOWING ADDITIONAL
        FUNCTIONS - <SubText className={"red"}>number of bets, </SubText>
        <SubText className={"green"}>Cashout at.</SubText>
      </Text>
      <Text className={"small white"} margin={"0 0 10px"}>
        *AUTOPLAY IS ACTIVATED BY CLICK ON
        <SubText className={"blue"}> autopilot </SubText> button
      </Text>
      <Text className={"small white"} margin={"0 0 10px"}>
        *AUTOPLAY CAN BE CLOSED BY CLICK ON
        <SubText className={"green"}> close autopilot </SubText> button
      </Text>
      <Text className={"small white"} margin={"0 0 10px"}>
        *<SubText className={"red"}> number of bets </SubText> FEATURE SETS
        AMOUNT OF ROUNDS THAT WILL BE PLAYED AUTO
      </Text>
      <Text className={"small white"} margin={"0 0 10px"}>
        *<SubText className={"green"}> cashout at </SubText> Feature SETS AMOUNT
        THAT YOU WANT TO <SubText className={"green"}> cashout </SubText>
      </Text>
      <Text className={"small white"} margin={"0 0 10px"}>
        *YOU
        <SubText className={"green"}> cashout </SubText> MANUALLY WITHOUT
        STOPPING <SubText className={"blue"}> autopilot </SubText>
      </Text>
      <Text className={"small white"} margin={"0 0 10px"}>
        *IN CASE OF
        <SubText className={"red"}> closing autopilot </SubText> IN CURRENT
        ROUND <SubText className={"blue"}> bet </SubText> will be{" "}
        <SubText className={"green"}> cashed out </SubText>
      </Text>
      <BetBlockWrapper>
        <BetBlock>
          <AutoPilot>autopilot</AutoPilot>
          <BetAmountContainer>
            <BetAmountWrapper>
              <BetAmount>
                <p>bet amount</p>
                <span>$100.00</span>
              </BetAmount>
              <Operations>
                <Operation color={"blue"}>1/2</Operation>
                <Operation>2x</Operation>
              </Operations>
            </BetAmountWrapper>
            <BetButton color={"blue"}>Bet</BetButton>
          </BetAmountContainer>
        </BetBlock>
      </BetBlockWrapper>
      <BetBlockWrapper>
        <BetBlock>
          <BetAmountContainer>
            <BetAmountWrapper>
              <BetAmount>
                <p>bet amount</p>
                <span>$100.00</span>
              </BetAmount>
              <Operations>
                <Operation color={"blue"}>1/2</Operation>
                <Operation>2x</Operation>
              </Operations>
            </BetAmountWrapper>
            <BetButton color={"red"}>Stop 10</BetButton>
          </BetAmountContainer>
          <BetAmountContainer margin="14px 0 0">
            <BetAmount>
              <p>number of bets</p>
              <span>10</span>
            </BetAmount>
            <BetAmount>
              <p>cashout at</p>
              <span>$100.00</span>
            </BetAmount>
          </BetAmountContainer>
          <AutoPilot margin="14px 0 0" className="red">
            close autopilot
          </AutoPilot>
        </BetBlock>
        <Text className={"big blue"}>
          Chashout Minimum Value -
          <SubText className={"white"}>
            <SubText className={"red"}> 1.01 {balance.currency};</SubText> Bet
            amount below
            <SubText className={"red"}> 1.01 {balance.currency} </SubText>can be
            placed but from ranges
            <SubText className={"green"}>
              {" "}
              0.10 {balance.currency}
            </SubText> to{" "}
            <SubText className={"green"}>1.01 {balance.currency} </SubText>
            Cashout at value will be
            <SubText className={"red"}> 1.01 {balance.currency}</SubText> no
            matter the value. Minimum multiplier for the bet range between{" "}
            <SubText className={"green"}> 0.10 {balance.currency}</SubText> to
            <SubText className={"green"}> 1.01 {balance.currency}</SubText> does
            not exist as bet is Cashed out at
            <SubText className={"red"}> 1.01 {balance.currency} </SubText> .
          </SubText>
        </Text>
        <Text className={"big blue"}>
          Cashout Maximum Value -
          <SubText className={"white"}>
            <SubText className={"red"}>
              {" "}
              {(config.maxbet * 5000).toFixed(config.prec)} {balance.currency};
            </SubText>{" "}
            Player can set bet amount Maximum in the amount of{" "}
            <SubText className={"red"}>
              {config.maxbet} {balance.currency}.
            </SubText>{" "}
            Maximum multiplier that is available in the game is{" "}
            <SubText className={"green"}>5000X. </SubText> Thus{" "}
            <SubText className={"green"}> Maximum </SubText>win amount is{" "}
            <SubText className={"red"}>
              {" "}
              {(config.maxbet * 5000).toFixed(config.prec)} {balance.currency}{" "}
            </SubText>
            equal to <SubText className={"green"}> Maximum </SubText>Cashout At
            value.
          </SubText>
        </Text>
      </BetBlockWrapper>
    </>
  )
}
